/**
 * Tarayıcıda küçük CSV dosyaları üretmek için (ör. içe aktarma hata listesi).
 * Excel (Türkçe) uyumu: UTF-8 BOM, `;` ayırıcı, CRLF satır sonu.
 * Hücre içeriği kullanıcının yüklediği dosyadan gelebileceği için `=`, `+`, `-`, `@`, sekme ve satır
 * başıyla başlayan metinler formül olarak çalışmasın diye başına `'` eklenir (sayılar hariç).
 */
export function csvCell(value: string | number | null | undefined): string {
  let v = value === null || value === undefined ? '' : String(value);
  if (/^[=+\-@\t\r]/.test(v) && !/^[+-]?\d+([.,]\d+)?$/.test(v)) v = `'${v}`;
  return /[";\r\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
}

export function toCsv(
  headers: readonly string[],
  rows: ReadonlyArray<ReadonlyArray<string | number | null>>,
) {
  return '\uFEFF' + [headers, ...rows].map((r) => r.map(csvCell).join(';')).join('\r\n');
}

/** Metni dosya olarak indirir. */
export function saveText(name: string, text: string, type = 'text/csv;charset=utf-8') {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
